import axios from 'axios';
import { API_URL } from '@/core/constants';

const api = axios.create({
  baseURL: API_URL,
});
api.defaults.withCredentials = true;

export { api };
